'use client';

import {
  BottomSheetTitle,
  BottomSheetTitleBox,
  BottomSheetTitleContainer,
  IcDelete,
  IconButton,
  Sheet,
  SheetContent,
  SheetPortal,
  SheetTrigger,
  Typography,
} from '@musinsa/mds';
import type React from 'react';
import { useState } from 'react';
import { usePreventBodyScroll } from '../../../../common/hooks/usePreventBodyScroll';
import { PrivacyPolicyContent } from './PrivacyPolicyContent';

interface PrivacyPolicyModalProps {
  children: React.ReactNode;
}

export const PrivacyPolicyModal = ({ children }: PrivacyPolicyModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  // 바텀시트 열렸을 때 뒤쪽 스크롤 방지
  usePreventBodyScroll({ open: isOpen });

  return (
    <Sheet direction="bottom" defaultOpen={false} open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>{children}</SheetTrigger>
      <SheetPortal>
        <SheetContent className="w-screen h-full bg-white flex flex-col">
          <BottomSheetTitle>
            <BottomSheetTitleContainer className="px-4 py-3">
              <BottomSheetTitleBox>
                <Typography variant="TextEtc16pxMed">개인정보 수집 및 이용 동의</Typography>
              </BottomSheetTitleBox>
              <IconButton size="size28x28" onClick={() => setIsOpen(false)}>
                <IcDelete />
              </IconButton>
            </BottomSheetTitleContainer>
          </BottomSheetTitle>
          <div className="bg-white h-full overflow-y-auto safe-area-bottom">
            <PrivacyPolicyContent />
          </div>
        </SheetContent>
      </SheetPortal>
    </Sheet>
  );
};
